module.exports = __webpack_public_path__ + "1bfa1875d29cec5485f72a4c9df72681.pdf";